import React, { FC }from "react";

import { IField } from "./../../../../../store/fields/types";
import { IRule } from "./../../../../../store/logic/types";
import { ILogicOptions } from "./../../../../../libs/logicSelect";
import Condition from "./Condition";

import styles from "./styles.module.scss";

interface IProps {
    currentRuleIndex: number;
    fieldIds: IField[];
    sortedConditionFields: ILogicOptions;
    currentRule: IRule;
    setCurrentRule: (newRule: IRule) => void;
}

const ConditionList: FC<IProps> = ({
    currentRuleIndex,
    fieldIds,
    sortedConditionFields,
    currentRule,
    setCurrentRule,
}) => {
    return (
        <div className={styles.conditions}>
            {currentRule.conditions.map((condition, index) => {
                return (
                    <Condition
                        condition={condition}
                        index={index}
                        currentRuleIndex={currentRuleIndex}
                        key={index}
                        fieldIds={fieldIds}
                        sortedConditionFields={sortedConditionFields}
                        currentRule={currentRule}
                        setCurrentRule={setCurrentRule}
                    />
                );
            })}
        </div>
    );
};

export default React.memo(ConditionList);
